<script>
import { deliveryInfoProps, useDeliveryInfo } from "./mixin";

import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import SecuredDownloadButton from "@/containers/secured-download-button";
import Divider from "@/components/atoms/divider";

import borne from "@/assets/icons/borne.svg";
import scanQrcode from "@/assets/icons/scan-qrcode.svg";
import scanBonRetrait from "@/assets/icons/scan-bon-retrait.svg";
import scanCartCora from "@/assets/icons/scan-cart-cora.svg";

export default {
  name: "OrderConfirmationDeliveryInfoDrive",
  components: {
    SecuredDownloadButton,
    LazyImage,
    List,
    ListItem,
    Divider
  },
  props: {
    ...deliveryInfoProps()
  },
  setup(props) {
    const { printFile, codeFormatted } = useDeliveryInfo(props);
    const Button = defineAsyncComponent(() =>
      import("@/components/atoms/button")
    );

    return {
      printFile,
      codeFormatted,
      borne,
      scanQrcode,
      scanBonRetrait,
      scanCartCora,
      Button
    };
  }
};
</script>

<template>
  <div class="u-border-grey-4 u-p-md u-radius-sm u-mb-md">
    <h2 class="u-font-24 u-color-primary u-mb-sm">
      4 possibilités pour retirer votre commande à la borne Drive
    </h2>
    <Divider
      dotted
      size="sm"
      class="u-mb-md"
    />

    <List class="c-order-confirmation__delivery-list">
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanCartCora"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Scannez votre carte à la borne
          </p>
          <p class="u-font-15 u-font-secondary">
            Présentez votre carte Malin, votre carte cora Cpay Mastercard ou la carte Scan Speedrive (gratuite et disponible auprès du personnel du drive).
          </p>
        </div>
      </ListItem>

      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanBonRetrait"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Scannez votre bon de retrait
          </p>
          <p class="u-font-15 u-font-secondary">
            <SecuredDownloadButton
              :component="Button"
              link
              :secured-link="pdfUrl"
              @download="printFile"
            >
              Imprimer le bon de retrait
            </SecuredDownloadButton>
          </p>
        </div>
      </ListItem>

      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanQrcode"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Scannez votre QR Code
          </p>
          <p class="u-font-15 u-font-secondary">
            Votre QR Code est disponible depuis l’application Cora
          </p>
        </div>
      </ListItem>

      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="borne"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Saisissez votre numéro de commande à la borne
          </p>
          <p class="u-font-15 u-font-secondary">
            {{ codeFormatted }}
          </p>
        </div>
      </ListItem>
    </List>
    <p class="u-font-14 u-color-grey-2 u-mb-xs u-mt-lg">
      Cora se réserve le droit de vous demander de présenter une pièce d’identité.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/order-confirmation.scss";
</style>
